import React from 'react';

const ColGroup = (props) => {
    return <colgroup>{
        props.columns.map(column => {
            const width = props.columnWidthValues[column.id];
            return <col data-resize-column-id={column.id} key={column.id} style={(!width || width === 0)
                ? { flex: 1, minWidth: '80px' }
                : { width: width + 'px' }
            }></col>
        })}
    </colgroup>
}

export default ColGroup;



// WEBPACK FOOTER //
// ./src/components/DataTable/Header/colgroup.js